import React, { useState } from 'react';

const DriverHeader = (
  {
    inputSearch, count, onSearch, onTextChange, handleAdd, onClearSearch,
    onBack, driver, formName,
    showBranches = false, branches = [], branchFilter = 0, onBranchFilter,
    driverTypeFilter = '', onDriverTypeFilter,
    statusFilter = 'Active', onStatusFilter
  }
) => {

  if (formName == 'add_edit') {
    return (
      <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-3 mb-4">
        <h1 className="text-xl font-bold uppercase text-[#293686]"> {driver ? `Edit Driver(${driver.driver_code})` : "Add Driver"} </h1>
        <div className="flex flex-col md:flex-row gap-2 w-full md:w-auto">
          <button
            onClick={onBack}
            className="bg-blue-600 uppercase text-white px-4 py-1.5 rounded hover:bg-blue-600 text-sm"
          >
            {"< Go Back"}
          </button>
        </div>
      </div>
    );
  } else if (formName == 'expense') {
    return (
      <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-3 mb-4">
        <h1 className="text-xl font-bold uppercase text-[#293686]">Driver Expense</h1>
      </div>
    );
  } else if (formName == 'attendance') {
    return (
      <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-3 mb-4">
        <h1 className="text-xl font-bold uppercase text-[#293686]">Driver Attendance</h1>
      </div>
    );
  }

  return (
    <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-3 mb-4">
      <h1 className="text-xl text-[#293686] font-bold uppercase">Drivers({count})</h1>
      <div className="flex flex-col md:flex-row gap-2 w-full md:w-auto">
        <form onSubmit={onSearch} className="relative w-full md:w-72">
          <input
            type="text"
            placeholder="Search by code, phone, email, etc."
            value={inputSearch}
            onChange={onTextChange}
            className="border rounded w-full pl-3 pr-10 py-1.5 text-sm"
          />
          {/* Clear (X) button — appears only when there's text */}
          {inputSearch && (
            <button
              type="button"
              onClick={onClearSearch}
              className="absolute right-8 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
              title="Clear"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-4 w-4"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          )}
          <button
            type="submit"
            className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
            title="Search"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M21 21l-4.35-4.35m0 0A7.5 7.5 0 104.5 4.5a7.5 7.5 0 0012.15 12.15z"
              />
            </svg>
          </button>
        </form>
        {showBranches && (
          <select
            value={branchFilter}
            onChange={onBranchFilter}
            className="border px-3 py-1.5 text-sm rounded"
          >
            <option value={0}>All Branches</option>
            {branches.map((b) => (
              <option key={b.id} value={b.id}>
                {b.name}
              </option>
            ))}
          </select>
        )}
        <select
          value={driverTypeFilter}
          onChange={onDriverTypeFilter}
          className="border px-3 py-1.5 text-sm rounded"
        >
          <option value="">All Driver Types</option>
          <option value="own">Own</option>
          <option value="market">Market</option>
        </select>
        <select
          value={statusFilter}
          onChange={onStatusFilter}
          className="border px-3 py-1.5 text-sm rounded"
        >
          <option value="All">All Status</option>
          <option value="Active">Active</option>
          <option value="Inactive">Inactive</option>
        </select>
        <button
          onClick={() => handleAdd("market")}
          className="bg-[#E91C24] uppercase text-white px-4 py-1.5 rounded hover:bg-[#E91C24] text-sm"
        >
          + Market Driver
        </button>
        <button
          onClick={() => handleAdd("own")}
          className="bg-[#E91C24] uppercase text-white px-4 py-1.5 rounded hover:bg-[#E91C24] text-sm"
        >
          + Own Driver
        </button>
      </div>
    </div>
  );
};

export default DriverHeader;
